import { createClient } from "@supabase/supabase-js";
import { apiFetch } from "./apiClient";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

const API = "/api/user-data";

// ── Subscriptions ─────────────────────────────────────────────────────────────

export async function getUserSubscription(clerkUserId) {
  const res = await apiFetch(`${API}?action=getSubscription&userId=${clerkUserId}`);
  if (!res.ok) return null;
  return res.json();
}

export async function getUserSubscriptionByEmail(email) {
  if (!email) return null;
  const res = await apiFetch(`${API}?action=getSubscriptionByEmail&email=${encodeURIComponent(email)}`);
  if (!res.ok) return null;
  return res.json();
}

export async function upsertUserSubscription(clerkUserId, email, updates = {}) {
  const res = await apiFetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "upsertSubscription", userId: clerkUserId, email, ...updates }),
  });
  if (!res.ok) return null;
  return res.json();
}

// ── Search Count (signed-in users) ────────────────────────────────────────────

export async function getSearchCount(clerkUserId) {
  const res = await apiFetch(`${API}?action=getSearchCount&userId=${clerkUserId}`);
  if (!res.ok) return { count: 0, tier: "free" };
  return res.json();
}

export async function incrementSearchCount(clerkUserId) {
  const res = await apiFetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "incrementSearchCount", userId: clerkUserId }),
  });
  if (!res.ok) return { count: 0 };
  return res.json();
}

// ── Search Count (anonymous users) ────────────────────────────────────────────

export async function getAnonSearchCount(sessionKey) {
  const res = await fetch(`${API}?action=getAnonSearchCount&sessionKey=${sessionKey}`);
  if (!res.ok) return { count: 0 };
  return res.json();
}

export async function incrementAnonSearchCount(sessionKey) {
  const res = await fetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "incrementAnonSearchCount", sessionKey }),
  });
  if (!res.ok) return { count: 0 };
  return res.json();
}